import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {ClassicType} from "../../shared/models/ClassicType";
import {map} from "rxjs/operators";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {ApiPathsService} from "../../api-paths.service";
import {json} from "ngx-custom-validators/src/app/json/validator";
import {Setting} from "../_models/setting";
import {Smtp} from "../_models/smtp";
import {RitornoPaginazione} from "../../shared/models/RitornoPaginazione";
import {TranslateObj} from "../../shared/models/translatedesc";

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService,
              private apiPaths: ApiPathsService,
              ) { }
  options() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.authenticationService.currentUserValue.access_token}`,
      }),
    };
  }
  ListSettings(): Observable<ClassicType[]> {
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/settings/list`,
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  GetSetting(value: Setting): Observable<ClassicType[]> {
    return this.http.post<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/settings/get`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  GetSettingLingue(value: Setting): Observable<TranslateObj[]> {
    return this.http.post<TranslateObj[]>(
      `${this.apiPaths.getBaseAPI()}/settings/get/lingue`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  AddSettings(value: Setting): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/settings/add`,
      JSON.stringify(value),
      this.options()).pipe(map(data => {
      return data;
    }));
  }
  UpdateSettings(value: Setting): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/settings/update`,
      JSON.stringify(value),
      this.options()).pipe(map(data => {
      return data;
    }));
  }
  DeleteSettings(value: Setting): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/settings/delete`,
      JSON.stringify(value),
      this.options()).pipe(map(data => {
      return data;
    }));
  }
  ListSmtp(value): Observable<RitornoPaginazione<Smtp[]>> {
    return this.http.post<RitornoPaginazione<Smtp[]>>(
      `${this.apiPaths.getBaseAPI()}/smtp/list`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  GetSmtp(value: Smtp): Observable<Smtp[]> {
    return this.http.post<Smtp[]>(
      `${this.apiPaths.getBaseAPI()}/smtp/get`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  AddSmtp(value: Smtp): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/smtp/add`,
      JSON.stringify(value),
      this.options()).pipe(map(data => {
      return data;
    }));
  }
  UpdateSmtp(value: Smtp): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/smtp/update`,
      JSON.stringify(value),
      this.options()).pipe(map(data => {
      return data;
    }));
  }
}
